import { render, staticRenderFns } from "./TagSelector.vue?vue&type=template&id=ed94d4de&scoped=true"
import script from "./TagSelector.vue?vue&type=script&lang=js"
export * from "./TagSelector.vue?vue&type=script&lang=js"
import "./TagSelector.vue?vue&type=style&index=0&id=ed94d4de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed94d4de",
  null
  
)

export default component.exports